import React, { useEffect, useRef, useState } from 'react';
import Modal from './Modal';
import Button from './Button';

let requestConfirm = null;

/**
 * Designed replacement for window.confirm: `if (!(await confirmDialog({...}))) return;`
 * Falls back to the browser dialog only when ConfirmHost is not mounted.
 */
export const confirmDialog = (options) => {
    const normalized = typeof options === 'string' ? { message: options } : options;
    if (requestConfirm) return requestConfirm(normalized);
    return Promise.resolve(window.confirm(normalized.message || normalized.title));
};

const useConfirm = () => confirmDialog;

export const ConfirmHost = () => {
    const [request, setRequest] = useState(null);
    const confirmButtonRef = useRef(null);

    useEffect(() => {
        const previous = requestConfirm;
        requestConfirm = (options) => new Promise((resolve) => {
            setRequest((current) => {
                current?.resolve(false);
                return { ...options, resolve };
            });
        });
        return () => {
            requestConfirm = previous;
        };
    }, []);

    useEffect(() => {
        if (request) confirmButtonRef.current?.focus();
    }, [request]);

    const settle = (value) => {
        request?.resolve(value);
        setRequest(null);
    };

    const danger = request?.danger !== false;

    return (
        <Modal
            show={Boolean(request)}
            onClose={() => settle(false)}
            title={request?.title || 'Подтвердите действие'}
            size="sm"
            className="confirm-dialog"
            footer={(
                <>
                    <Button variant="secondary" onClick={() => settle(false)}>
                        {request?.cancelLabel || 'Отмена'}
                    </Button>
                    <Button
                        ref={confirmButtonRef}
                        variant={danger ? 'danger' : 'primary'}
                        onClick={() => settle(true)}
                    >
                        {request?.confirmLabel || (danger ? 'Удалить' : 'Подтвердить')}
                    </Button>
                </>
            )}
        >
            <p className="confirm-dialog-message">{request?.message}</p>
        </Modal>
    );
};

export default useConfirm;
